import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { Component, createElement } from 'react';
import { cloneEnumerableProperty } from './clone-enumerable-property';
var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
export function isReactClass(obj) {
  return obj && obj.prototype && (obj.prototype.isReactComponent || obj.prototype instanceof Component);
}
export function acceptsRef(obj) {
  var _obj$prototype;

  return (obj === null || obj === void 0 ? void 0 : (_obj$prototype = obj.prototype) === null || _obj$prototype === void 0 ? void 0 : _obj$prototype.isReactComponent) || obj.$$typeof && obj.$$typeof === REACT_FORWARD_REF_TYPE;
}

function isForwardRefType(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj.$$typeof) && (obj === null || obj === void 0 ? void 0 : obj.$$typeof) === REACT_FORWARD_REF_TYPE;
}

export function isReactComponent(obj) {
  return obj && (isReactClass(obj) || typeof obj === 'function' || isForwardRefType(obj));
}
export function wrapReactClass(view) {
  var ViewComponentClass = /*#__PURE__*/function (_Component) {
    _inheritsLoose(ViewComponentClass, _Component);

    function ViewComponentClass() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = ViewComponentClass.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/createElement(view, this.props);
    };

    return ViewComponentClass;
  }(Component);

  ViewComponentClass = cloneEnumerableProperty(ViewComponentClass, view);
  ViewComponentClass.displayName = view.displayName;
  return ViewComponentClass;
}